import React, { useCallback } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { FaPowerOff } from 'react-icons/fa';
import packageJson from '../../../package.json';
import logo from '../../assets/SGRLock_icon.png';
import logoSwint from '../../assets/swintLogo.svg';
import { useAuth } from '../../contexts/authContext';
import { useSteps } from '../../contexts/stepContext';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import LanguageSwitch from '../LanguageSwitch';
import Steps from '../Steps';
import {
  Container,
  ContentImgs,
  ContentSection,
  Header,
  MobileImgs,
  UserData,
  Version,
} from './styles';

const BodyStep: React.FC = ({ children }) => {
  const { companyName, signOut, userName, apiVersion } = useAuth();
  const { currentStep, currentValidation, clearData } = useSteps();
  const { translationPage } = useAppTranslation();
  const { tp } = translationPage(tr => tr.components.bodyStep);

  const handleSignOut = useCallback(() => {
    clearData();
    signOut();
  }, [clearData, signOut]);

  return (
    <Container
      firstStep={currentStep === 1 && isMobileOnly}
      nextSteps={currentStep > 1 && isMobileOnly}
    >
      {/* <LanguageSwitch /> */}
      {isMobileOnly ? (
        <>
          {currentStep !== 1 ? (
            <>
              <Header>
                {/* <LanguageSwitch /> */}
                <h1>
                  {tp('identificationBy', { validation: currentValidation })}
                </h1>
                <Steps />
              </Header>
              <ContentSection>{children}</ContentSection>
            </>
          ) : (
            <>
              <MobileImgs>
                <img src={logo} alt="" />
                <img src={logoSwint} alt="" />
              </MobileImgs>
              <ContentSection>{children}</ContentSection>
              <UserData>
                <p>
                  <span>{tp('companyLabel')}</span> {companyName}
                </p>
                <p>
                  <span>{tp('userLabel')}</span> {userName}
                </p>
                <button onClick={handleSignOut} type="button">
                  <FaPowerOff size={16} />
                  {tp('signOut')}
                </button>
              </UserData>
              <Version>
                <p>
                  {tp('versionLabel')} {packageJson.version}
                </p>
                <p>
                  {tp('apiVersionLabel')} {apiVersion}
                </p>
              </Version>
            </>
          )}
        </>
      ) : (
        <>
          <ContentImgs>
            <img src={logo} alt="" />
            <img src={logoSwint} alt="" />
          </ContentImgs>

          <Header>
            <LanguageSwitch />
            {currentValidation !== '' && (
              <h1>
                {tp('identificationBy', { validation: currentValidation })}
              </h1>
            )}
            {currentStep !== 1 && <Steps />}
          </Header>
          <ContentSection>{children}</ContentSection>
          <UserData>
            <p>
              <span>{tp('companyLabel')}</span> {companyName}
            </p>
            <p>
              <span>{tp('userLabel')}</span> {userName}
            </p>
            <button onClick={handleSignOut} type="button">
              <FaPowerOff size={16} />
              {tp('signOut')}
            </button>
          </UserData>
          <Version>
            <p>
              {tp('versionLabel')} {packageJson.version}
            </p>
            <p>
              {tp('apiVersionLabel')} {apiVersion}
            </p>
          </Version>
        </>
      )}
    </Container>
  );
};

export default BodyStep;
